export const env = typeof window === 'object' ? process.env.NEXT_PUBLIC_APP_ENV : process.env.APP_ENV;

export const isLocal = env === 'local';

const baseURLMapping = {
  local: '/apis',
  dev: 'https://dev-item.szlcsc.com',
  fat: 'https://fat-item-next.szlcsc.com',
  uat: 'https://uatitem.szlcsc.com',
  pro: 'https://item.szlcsc.com',
};

export const baseURL = baseURLMapping[env];

const h5BaseURLMapping = {
  local: '',
  dev: 'https://devm.szlcsc.com',
  fat: 'https://fatm.szlcsc.com',
  uat: 'https://uatm.szlcsc.com',
  pro: 'https://m.szlcsc.com',
};

export const h5BaseURL = h5BaseURLMapping[env];
